import { organizationsRepo } from '@/constants/providers';
import { UserKey } from '@/modules/Users/queries/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { DisassociateOrganizationUserModel } from '../types/disassociate-organization-user-model';
import { OrganizationKeys } from './keys';

export const useDisassociateOrganizationUser = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, unknown, DisassociateOrganizationUserModel>(
    (disassociateOrganizationUser) =>
      organizationsRepo.disassociateUser(disassociateOrganizationUser),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(UserKey.ALL);
        queryClient.invalidateQueries(OrganizationKeys.ALL);
      },
      onError: () => {
        toast.error(t('error.disassociate_user_organization'));
      },
    },
  );
};
